import { Link } from 'react-router-dom';

const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Vaciado de pisos',
      description: 'Servicio completo de vaciado de viviendas, retirando muebles, enseres y todo tipo de objetos. Incluye limpieza final.',
      image: 'https://public.readdy.ai/ai/img_res/e21c9bf58d83b47b47c592ee5c7d9886.jpg',
    },
    {
      icon: 'ri-store-2-line',
      title: 'Vaciado de locales',
      description: 'Vaciado profesional de oficinas, tiendas y espacios comerciales. Gestión completa de mobiliario y equipamiento.',
      image: 'https://readdy.ai/api/search-image?query=Empty%20commercial%20office%20space%20bright%20modern%20interior%20clean%20environment&width=600&height=400&seq=service-commercial&orientation=landscape',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Limpieza Diógenes',
      description: 'Especialistas en limpieza extrema con máxima discreción. Equipo profesional para situaciones delicadas.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20team%20protective%20equipment%20deep%20cleaning%20bright%20workspace&width=600&height=400&seq=service-diogenes&orientation=landscape',
    },
    {
      icon: 'ri-delete-bin-line',
      title: 'Retirada de muebles',
      description: 'Recogida y transporte de muebles voluminosos y electrodomésticos. Gestión responsable de residuos.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20carrying%20furniture%20organized%20removal%20service%20bright%20environment&width=600&height=400&seq=service-furniture&orientation=landscape',
    },
    {
      icon: 'ri-inbox-unarchive-line',
      title: 'Vaciado de trasteros',
      description: 'Limpieza completa de trasteros y espacios de almacenamiento. Clasificación y gestión de enseres.',
      image: 'https://readdy.ai/api/search-image?query=Storage%20room%20clearance%20organized%20removal%20bright%20clean%20space%20professional%20service&width=600&height=400&seq=service-storage&orientation=landscape',
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Pintura final',
      description: 'Servicio de pintura profesional para dejar el inmueble completamente listo. Acabados impecables.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20painter%20painting%20white%20walls%20bright%20clean%20room%20modern%20interior%20quality%20work&width=600&height=400&seq=service-painting&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-primary uppercase tracking-wide">Nuestros servicios</span>
          <h2 className="text-4xl md:text-5xl font-bold text-graphite mt-3 mb-4">
            Soluciones profesionales de<br />
            <span className="text-primary">vaciado y limpieza</span>
          </h2>
          <p className="text-lg text-gray-medium max-w-2xl mx-auto">
            Ofrecemos servicios integrales de vaciado de pisos, locales y limpieza extrema en Castelldefels, adaptados a las necesidades de particulares, inmobiliarias y administradores de fincas
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <Link to="/servicios" className="lg:row-span-2 group cursor-pointer">
            <div className="relative h-full rounded-3xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-2">
              <img
                src={services[0].image}
                alt={services[0].title}
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
                width="800"
                height="600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <span className="inline-block px-4 py-2 bg-primary/90 backdrop-blur-sm text-white text-xs font-semibold rounded-full mb-4">
                  {services[0].badge}
                </span>
                <h3 className="text-2xl font-bold text-white mb-3">{services[0].title}</h3>
                <p className="text-white/90 text-sm leading-relaxed">{services[0].description}</p>
              </div>
            </div>
          </Link>

          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
            {services.slice(1).map((service, index) => (
              <Link to="/servicios" key={index} className="group cursor-pointer">
                <div className="relative h-80 rounded-3xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-2">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                    width="800"
                    height="600"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <span className="inline-block px-4 py-2 bg-accent text-graphite text-xs font-semibold rounded-full mb-3">
                      {service.badge}
                    </span>
                    <h3 className="text-xl font-bold text-white mb-2">{service.title}</h3>
                    <p className="text-white/90 text-sm leading-relaxed">{service.description}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Link
            to="/servicios"
            className="inline-flex items-center px-8 py-4 bg-primary text-white rounded-lg font-semibold text-lg hover:bg-primary-dark hover:shadow-glow transition-all cursor-pointer whitespace-nowrap"
          >
            Ver todos los servicios
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
